"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _axios = _interopRequireDefault(require("axios"));
var _store = _interopRequireDefault(require("@/store"));
var _file = require("@ys/utils/lib/file");
var _upload = require("@/api/upload");
var _default = exports.default = {
  name: 'BasisUpload',
  // 文件上传
  props: {
    // 可通过v-model获取文件列表；和change事件二选一用于绑定数据即可
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 上传平台 qiniu七牛云 | oss阿里云OSS
    platform: {
      type: String,
      default: 'qiniu',
      validator: value => {
        return ['qiniu', 'oss'].indexOf(value) !== -1;
      }
    },
    // 上传方式 client浏览器端上传（从性能角度出发，优先使用client） | server服务端上传
    mode: {
      type: String,
      default: 'client',
      validator: value => {
        return ['client', 'server'].indexOf(value) !== -1;
      }
    },
    // 接受上传的文件类型, 详见 input accept Attribute https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
    accept: {
      type: String,
      default: ''
    },
    // 上传的地址 string|(file) => Promise。mode为server时生效
    action: {
      type: [String, Function],
      default: '/api/v1/qiniu/file/upload' // 由于自动上传时使用<a-upload></a-upload>的默认上传功能，上传地址需要是完整路径，无法使用本地开发的代理
    },
    // 限制上传的文件最大数量 0表示不受限制
    limit: {
      type: Number,
      default: 0
    },
    // 文件大小限制，单位MB，0表示不受限制
    size: {
      type: Number,
      default: 0
    },
    // 上传七牛云时的key前缀
    keyPrefix: {
      type: String,
      default: () => {
        return _store.default.getters.keyPrefix || '';
      }
    },
    // 上传错误时的错误提示,a-upload默认提示“上传错误”
    errMsg: {
      type: String,
      default: '上传错误'
    },
    // 默认已经上传的文件列表
    defaultFileList: {
      type: Array,
      default: undefined
      // default: () => {
      //   return [
      //     // 回填数据的默认格式
      //     // {
      //     //   uid: 1, // 必填，没有时可以使用url，否则显示列表时报错
      //     //   name: 'img.png', // listType为text和picture时必填，否则显示列表时报错
      //     //   url: 'https://qiniu-dev.wszn.top/920691/cm/1628770717016.png' // 必填
      //     //   // status: 'error', // 状态有：uploading done error removed pending-等待上传，当status=pending时，这里必须是file对象
      //     //   // response: 'Server Error 500' // 自定义的错误提示，status为error时显示
      //     // }
      //   ]
      // }
    },
    // 设置上传的请求头部，IE10 以上有效
    headers: {
      type: Object,
      default: () => {
        return {
          accessToken: _store.default.getters.accessToken
        };
      }
    },
    // 上传列表的内建样式，支持三种基本样式 text, picture 和 picture-card
    listType: {
      type: String,
      default: 'text'
    },
    // 是否支持多选文件，ie10+ 支持。开启后按住 ctrl 可选择多个文件。
    multiple: {
      type: Boolean,
      default: true
    },
    // 是否自动上传
    autoUpload: {
      type: Boolean,
      default: true
    },
    // 隐藏上传按钮入口，一般配合showUploadList:false和autoUpload:false进行使用。
    // 使用场景：某个只需要上传功能，不需要显示文件列表的业务
    hideEntry: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileDomain: '',
      // 文件访问域名
      uploadUrl: '',
      // 直传七牛云时的源站上传域名
      uploadData: {
        token: '',
        key: '' // key：租户ID/clientId去除_admin/唯一文件编码.后缀
      },
      fileList: [] // 文件列表
    };
  },
  computed: {
    // 不同上传方式所需的属性
    uploadAttrs() {
      if (this.mode === 'server') {
        return {
          headers: this.headers,
          action: this.action,
          ...this.$attrs
        };
      }
      return {
        data: this.uploadData,
        action: this.uploadUrl,
        ...this.$attrs
      };
    },
    allUids() {
      return this.fileList.map(item => item.uid);
    }
  },
  watch: {
    defaultFileList: {
      handler(val) {
        if (val) {
          this.fileList = val;
          this.$emit('change', {
            fileList: val
          });
        }
      },
      immediate: true,
      deep: true
    },
    fileList: {
      handler(val) {
        this.$emit('input', val);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 开始手动上传 返回最新的文件列表 [file,file]
    startUpload() {
      return Promise.all(this.fileList.map(file => this.uploadSingleFile(file)));
    },
    uploadSingleFile(file) {
      // 非待上传状态的文件直接返回
      if (file.status !== 'pending') {
        return Promise.resolve(file);
      }
      return new Promise(async (resolve, reject) => {
        try {
          file.status = 'uploading';
          // 由于内部修改file的属性，这里进行强制刷新，否则视图会不更新上传中的状态
          this.fileList.splice(0, 0);
          const formData = new FormData();
          formData.append('file', file);
          if (this.mode === 'client') {
            await this.getUploadToken(file);
            formData.append('token', this.uploadData.token);
            formData.append('key', this.uploadData.key);
          }
          const apiUrl = this.mode === 'client' ? this.uploadUrl : this.action;
          const res = await _axios.default.post(apiUrl, formData, {
            headers: this.headers
          });
          file.status = 'done';
          file.response = res.data;
          this.onChange({
            file,
            fileList: this.fileList
          });
          resolve(file);
        } catch (error) {
          file.response = error.response.data || error;
          this.onChange({
            file,
            fileList: this.fileList
          });
          reject(error);
        }
      });
    },
    /**
     * @description: 获取上传凭证 mode=client时生效
     * @param {*} file 当前操作的文件对象
     */
    async getUploadToken(file) {
      try {
        // TODO: 接入阿里云OSS上传
        const {
          domain,
          uploadToken,
          uploadUrl
        } = await (0, _upload.getQiniuUploadToken)();
        this.fileDomain = domain;
        this.uploadUrl = uploadUrl;
        this.uploadData = Object.assign(this.uploadData, {
          token: uploadToken,
          key: `${this.keyPrefix}${new Date().getTime()}.${(0, _file.getExtension)(file)}`
        });
        return true;
      } catch (error) {
        return false;
      }
    },
    /**
     * @description: 上传文件之前的钩子，参数为上传的文件，若返回 false 则停止上传
     * @param {*} file
     * @return {Boolean} true/false
     */
    // eslint-disable-next-line max-statements
    beforeUpload(file) {
      const isValidFileType = (0, _file.validFileType)(file, this.accept);
      const isValidFileSize = (0, _file.validFileSize)(file, this.size);
      const isValidFileNum = !(this.fileList.length >= this.limit && this.limit > 1);
      if (!isValidFileType || !isValidFileSize || !isValidFileNum) {
        let msg = '';
        if (!isValidFileType) {
          msg = `只能上传“${this.accept}”格式的文件。`;
        }
        if (!isValidFileSize) {
          msg = `单个文件大小必须小于${this.size}MB！`;
        }
        if (!isValidFileNum) {
          msg = `最多上传${this.limit}个文件。`;
        }
        this.$error({
          content: msg
        });
        file.validate = false; // 标识为无效文件，在onChange自动删除
        return false;
      }
      if (this.autoUpload) {
        if (this.mode === 'client') {
          return this.getUploadToken(file);
        }
        return true;
      }
      file.status = 'pending'; // 等待上传
      // 如果限制为一个，则默认替换上一个
      this.limit === 1 ? this.fileList = [file] : this.fileList.push(file);
      return false;
    },
    /**
     * @description: 文件状态改变的回调 上传中、完成、失败、删除都会调用这个函数
     * @param {*} file 当前操作的文件对象
     * @param {*} fileList 当前的文件列表
     * @param {*} event 上传中的服务端响应内容，包含了上传进度等信息，高级浏览器支持。
     */
    onChange({
      file,
      fileList,
      event
    }) {
      const {
        uid,
        response = {}
      } = file;
      const index = this.allUids.indexOf(uid);
      // 不符合要求的从列表中删除
      if (file.validate === false) {
        fileList.splice(index, 1);
        return;
      }
      // 如果限制为一个且未被删除，则默认替换上一个
      if (this.limit === 1 && file.status !== 'removed') {
        fileList = [file];
      }
      // 使用服务端上传且接口返回错误
      if (response.code && response.code !== '00000') {
        file.status = 'error';
        fileList[index].status = 'error';
      }
      if (file.status === 'done') {
        fileList[index].url = this.mode === 'client' ? `${this.fileDomain}/${response.key}` : response.data.url;
      }
      if (file.status === 'error') {
        fileList[index].response = response.msg || this.errMsg;
      }
      this.fileList = fileList;
      this.fileList.splice(0, 0); // 由于内部修改file的属性，这里进行强制刷新，否则视图会不更新
      this.$emit('change', {
        file,
        fileList,
        event
      });
    },
    // 拖拽文件不符合 accept 类型时的回调
    onReject(fileList) {
      if (fileList.length > 0) {
        this.$error({
          content: `只能上传“${this.accept}”格式的文件。`
        });
      }
    }
  }
};